module.exports = __webpack_public_path__ + "static/scale-model-of-harley-davidson-museum-in-milwaukee-wisconsin-92256a9dd6b17538863a0f09d084fff8.png";